import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'

class AlertMini extends Component {
  constructor(props) {
    super(props)
    this.state = {
      alertIsMinimized: false,
      alertIsHidden: false
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      menuState: nextProps.menuState,
      alertData: nextProps.alertData,
      alertIsMinimized: nextProps.alertIsMinimized,
      alertIsHidden: nextProps.alertIsHidden
    })
  }
  render() {
    let smallText, button
    if (this.state.alertData) {
      let d = this.state.alertData
      button = d['button']
      smallText = d['small-text']
    }

    let minimizedAlert = <span></span>

    // {smallText}
    // {button}
    if (true) {
      minimizedAlert = (
        <div className="alert-mini fade-in" id="alertMini">
          <h5>
            <a href="/camps?utm_source=gakko&utm_medium=banner&utm_campaign=sempai">Summer 2018 sempai applications</a> extended. <a href="/camps#apply">Apply</a> by January 11th!<br/>
          </h5>
        </div>
      )
    }
    return (
      minimizedAlert
    )
  }
}
AlertMini.contextTypes = {
}
AlertMini.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    menuState: state.token.menuState,
    alertData: state.token.alertData,
    alertIsHidden: state.token.alertIsHidden
  }
}

export default connect(mapStateToProps)(AlertMini)



// WEBPACK FOOTER //
// ./src/components/Utils/AlertMini.js